import isProd from './isProduction.ts'
import { HEADING, SUBHEADING } from './defaults'

export const endpoints = (prod = isProd()) => ({
  authApiUrl: prod ? 'https://writing.chegg.com/api/auth' : 'https://writing.test.cheggnet.com/api/auth',
  editorBaseUrl: prod ? 'https://writing.chegg.com' : 'https://writing.test.cheggnet.com',
})

const chegg = ({
  site = 'chegg',
  headingText = HEADING,
  subheadingText = SUBHEADING,
  pasteOnly = false,
  alignText = 'center',
  initRSW = true,
  initFreshToken = true,
} = {}) => {
  const { authApiUrl, editorBaseUrl } = endpoints()

  return {
    headingText,
    subheadingText,
    authApiUrl,
    editorBaseUrl,
    pasteOnly,
    alignText,
    site,
    initFreshToken,
    initRSW,
  }
}

export default chegg
